import React, { useState } from "react";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Instrument_Check_Report_Table from "./instrument_check_report_table/Instrument_Check_Report_Table";
import Instrument_Check_Report_Filter from "./instrument_check_report_filter/Instrument_Check_Report_Filter";


const Instrument_Check_Report = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Instrument_Check_Report_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Instrument_Check_Report_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Instrument Check Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Instrument_Check_Report;
